// Pendiente de revisar
import i18n from "@/i18n/i18n";
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class ExperimentDeploymentDto extends ItiBaseDto {
	public deploymentId: string;
	public deploymentStatus: string;
	public vscUrl: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}

	public get translatedStatus() {
		return i18n.t(`status.${this.deploymentStatus.toLocaleLowerCase()}`);
	}
}
